import React, { useRef, useState } from "react";
import { Form, Overlay, Tooltip } from "react-bootstrap";
import InputDetail from "./InputDetail";
import infobtn from "../../assets/images/infobtnblue.svg";
import Select from "react-select";
import { ENUMS } from "../../services/Enums";
const MultiSelect = ({ compObj, handleChange, isDisable, showtype, labelAction, nodeContext }) => {
  let dropDownOption = compObj?.paravalueselection
    ? eval(compObj?.paravalueselection)
    : [];
  let finalOptions = [];
  dropDownOption?.forEach((item) => {
    finalOptions?.push({
      label: item,
      value: item,
    });
  });

  const selectedValues = compObj?.value?.map((val) => ({
    label: val,
    value: val,
  }));

  const [showInputDetailPopup, setShowInputDetailPopu] = useState(false);
  const targetInputDetail = useRef();

  const handleOverlay = (e) => {
    let element = document.getElementById(e?.currentTarget?.id);
    if (element) {
      if (element.classList.contains("overlay-isopen")) {
        element.classList.remove("overlay-isopen");
      } else {
        element.classList.add("overlay-isopen");
      }
    }
  };

  const handleShowInputDetailPopup = (e) => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
      handleOverlay(e);
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowInputDetailPopu(!showInputDetailPopup);
  };

  return (
    <div>
      <div className="config-input-label-container">
        <Form.Label className="common-label text-capitalize">
          {compObj?.parakey.replaceAll("_", " ")}
          {showtype && <> ({compObj?.paratype})</>}
        </Form.Label>
        {compObj?.details && (
          <span
            className="config-info-btn cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              handleOverlay(e);
              setShowInputDetailPopu(!showInputDetailPopup);
              handleShowInputDetailPopup();
            }}
            ref={targetInputDetail}
          >
            <img src={infobtn} alt="infobtn" />
          </span>
        )}
        {
          !ENUMS.workflowparamsnotbindonthiskey.includes(compObj?.parakey.toUpperCase()) &&
          labelAction
        }
      </div>

      <Select
        options={finalOptions}
        isMulti
        value={selectedValues}
        onChange={(e) => {
          if (handleChange) {
            let temp = [];
            e.forEach((element) => {
              temp.push(element?.value);
            });
            handleChange(temp, compObj);
          }
        }}
        disabled={isDisable ? isDisable : false}
      />
      {showInputDetailPopup && (
        <Overlay
          target={targetInputDetail.current}
          show={handleShowInputDetailPopup}
          placement="bottom"
          flip
        >
          <Tooltip id="overlay-example">
            <InputDetail
              handleshowPopup={handleShowInputDetailPopup}
              compObj={compObj}
            />
          </Tooltip>
        </Overlay>
      )}
    </div>
  );
};

export default MultiSelect;
